import gql from 'graphql-tag';

export default gql`
	query CreditCardDefault {
		creditCardDefault @client {
			isDefault
		}
	}
`;
